/* Bundle card content, matched to the reference site's format.

   badge  STARTER / MOST POPULAR / BEST VALUE -> "25% OFF", computed in Liquid from the
          variant's real compare_at_price. No compare-at in the current market (the
          Europe market has none) -> the badge is hidden rather than showing "0% OFF".
   name   "60 ml · 2 bottles" - confirmed by Guy: the options are quantity bundles, so
          30 ml is one bottle, 60 ml two, 90 ml three.
   desc   spells out the pack for multi-bottle options ("2 × 30 ml"), because "60 ml"
          alone reads as one larger bottle. Skipped for the single, where it would just
          repeat the name. Price per ml is arithmetic from the real price.
   CTA    "Add to cart - $79.00" -> "Add to cart"; their CTA carries no price.

   The buy-box size buttons get the same pack count, so the two modules on the page
   cannot disagree with each other.

   Runs repeatedly because the section re-renders these nodes. */
(function(){
var B=window.LUMA_BUNDLE; if(!B||!B.cards) return;

function word(n){ return n===1 ? B.bottle_one : B.bottle_many; }

function variantOf(el){
  var inp=el.querySelector('input[name=id]') || el.querySelector('input[value]');
  return inp?String(inp.value):null;
}

function apply(){
  var cards=document.querySelectorAll('.lp .bcard');
  var sizes=document.querySelectorAll('.lp .size');
  if(!cards.length && !sizes.length) return false;

  cards.forEach(function(card){
    var id=variantOf(card);
    var d=id?B.cards[id]:null;
    if(!d) return;

    var badge=card.querySelector('.bbadge');
    if(badge){
      if(d.pct&&d.pct>0){
        var want=d.pct+'% '+B.off;
        if(badge.textContent.trim()!==want) badge.textContent=want;
        badge.style.display='';
      }else{
        badge.style.display='none';
      }
    }

    var name=card.querySelector('.bname');
    if(name && d.bottles>0){
      var nm=d.title+' · '+d.bottles+' '+word(d.bottles);
      if(name.textContent.trim()!==nm) name.textContent=nm;
    }

    var desc=card.querySelector('.bdesc');
    if(desc){
      var parts=[];
      if(d.bottles>1) parts.push(d.bottles+' × 30 ml');   /* redundant on the single */
      if(d.perml) parts.push(d.perml+' '+B.per_ml);
      parts.push(d.tag);
      var txt=parts.join(' · ');
      if(desc.textContent.trim()!==txt) desc.textContent=txt;
    }

    var btn=card.querySelector('.baddbtn');
    if(btn && btn.textContent.indexOf('—')>-1) btn.textContent=B.add;
  });

  /* size buttons: append the pack count so "90 ml" cannot read as one bottle */
  sizes.forEach(function(sz){
    var id=variantOf(sz);
    var d=id?B.cards[id]:null;
    if(!d||!d.bottles||d.bottles<1) return;
    if(sz.querySelector('.lbot')) return;
    var s=document.createElement('span');
    s.className='lbot';
    s.textContent=d.bottles+' '+word(d.bottles);
    var host=sz.querySelector('.s1')||sz.firstElementChild||sz;
    host.appendChild(s);
  });

  return true;
}

document.addEventListener('DOMContentLoaded',function(){
  if(apply()) return;
  var n=0,iv=setInterval(function(){ n++; if(apply()||n>40) clearInterval(iv); },100);
});
window.addEventListener('load',function(){ [300,1200].forEach(function(t){ setTimeout(apply,t); }); });
})();